/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import { Badge, Button, Tabs, Tooltip } from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ROUTER } from '../../../../constants/router';
import PreviewArticle from './PreviewArticle';
import usePermission from '../../../../hooks/usePermission';

const { TabPane } = Tabs;

export default function DocTabs({
    currentSelectList,
    previewLang,
    privacyPolicyNoticeId,
    loading,
    detail,
    detailPublished,
    logo,
    logoPublish,
}) {
    const { t } = useTranslation();
    const [currentTab, setCurrentTab] = useState('policy');
    const { isAuditor } = usePermission();

    return (
        <div className="flex">
            <Tabs
                size="small"
                defaultActiveKey={currentTab}
                className="mt-5 w-full"
                onChange={(e) => {
                    setCurrentTab(
                        e === 'policy'
                            ? 'policy.viewpolicy'
                            : e === 'plaintext'
                            ? 'policy.Plaintext'
                            : 'policy.HtmlCode'
                    );
                }}
            >
                {currentSelectList?.status === 'Draft' && (
                    <TabPane
                        tab={
                            <span className="font-semibold">
                                {t('policy.viewpolicy')}
                            </span>
                        }
                        key="policy"
                    >
                        <Badge.Ribbon
                            text={
                                currentSelectList?.status +
                                ' ' +
                                currentSelectList?.version
                            }
                            color="#1890FF"
                        >
                            {detail && (
                                <div className="max-h-[700px] overflow-y-auto pb-6 mb-4">
                                    <PreviewArticle
                                        logo={logo}
                                        loading={loading}
                                        detail={detail}
                                        lang={previewLang}
                                        privacyPolicyId={privacyPolicyNoticeId}
                                    />
                                </div>
                            )}
                        </Badge.Ribbon>
                    </TabPane>
                )}

                {currentSelectList?.status === 'Published' &&
                    !currentSelectList?.hasChanged && (
                        <TabPane
                            tab={
                                <span className="font-semibold">
                                    {t('Preview policy published')}
                                </span>
                            }
                            key="published"
                        >
                            <Badge.Ribbon
                                text={
                                    currentSelectList?.status +
                                    ' ' +
                                    currentSelectList?.latestPublishVersion
                                }
                                color="#4ACE8F"
                            >
                                {detail && (
                                    <div className="max-h-[700px] overflow-y-auto pb-6 mb-4">
                                        <PreviewArticle
                                            logo={logo}
                                            loading={loading}
                                            detail={detail}
                                            lang={previewLang}
                                            privacyPolicyId={
                                                privacyPolicyNoticeId
                                            }
                                        />
                                    </div>
                                )}
                            </Badge.Ribbon>
                        </TabPane>
                    )}

                {currentSelectList?.status === 'Published' &&
                    currentSelectList?.hasChanged && (
                        <>
                            <TabPane
                                tab={
                                    <span className="font-semibold">
                                        {t('policy.viewpolicy')}
                                    </span>
                                }
                                key="policy"
                            >
                                <Badge.Ribbon
                                    text={
                                        'Last Updated' +
                                        ' ' +
                                        currentSelectList?.version
                                    }
                                    color="#1890FF"
                                >
                                    {detail && (
                                        <div className="max-h-[700px] overflow-y-auto pb-6 mb-4">
                                            <PreviewArticle
                                                logo={logo}
                                                loading={loading}
                                                detail={detail}
                                                lang={previewLang}
                                                privacyPolicyId={
                                                    privacyPolicyNoticeId
                                                }
                                            />
                                        </div>
                                    )}
                                </Badge.Ribbon>
                            </TabPane>
                            <TabPane
                                tab={
                                    <span className="font-semibold">
                                        {t('Preview policy published')}
                                    </span>
                                }
                                key="published"
                            >
                                <Badge.Ribbon
                                    text={
                                        currentSelectList?.status +
                                        ' ' +
                                        currentSelectList?.latestPublishVersion
                                    }
                                    color="#4ACE8F"
                                >
                                    {detailPublished && (
                                        <div className="max-h-[700px] overflow-y-auto pb-6 mb-4">
                                            <PreviewArticle
                                                logo={logoPublish}
                                                loading={loading}
                                                detail={detailPublished}
                                                lang={previewLang}
                                                privacyPolicyId={
                                                    privacyPolicyNoticeId
                                                }
                                            />
                                        </div>
                                    )}
                                </Badge.Ribbon>
                            </TabPane>
                        </>
                    )}
            </Tabs>
            <div className="absolute right-14 mt-6 cursor-pointer hover:opacity-80">
                <Tooltip title="Edit Privacy">
                    <Link
                        to={
                            currentSelectList?.status === 'Draft'
                                ? `${ROUTER.POLICY.VENDOR_PRIVACY}/${privacyPolicyNoticeId}#step1`
                                : `${ROUTER.POLICY.VENDOR_PRIVACY}/${privacyPolicyNoticeId}#step9`
                        }
                    >
                        <Button
                            disabled={isAuditor}
                            type="primary"
                            className="px-8"
                            ghost
                        >
                            {t('Edit')}
                        </Button>
                    </Link>
                </Tooltip>
            </div>
        </div>
    );
}
